export const GOOGLE_DOCS_DOCUMENT_LINK = "https://docs.google.com/document/d/";
export const GOOGLE_DOCS_SPREADSHEETS_LINK = "https://docs.google.com/spreadsheets/d/";
export const GOOGLE_DOCS_PRESENTATION_LINK = "https://docs.google.com/presentation/d/";
export const GOOGLE_DOCS_FORMS_LINK = "https://docs.google.com/forms/d/";

export const RUTUBE_LINK = "https://rutube.ru/";

const PREFIXES = [
    GOOGLE_DOCS_DOCUMENT_LINK,
    GOOGLE_DOCS_SPREADSHEETS_LINK,
    GOOGLE_DOCS_PRESENTATION_LINK,
    GOOGLE_DOCS_FORMS_LINK,
    RUTUBE_LINK,
];

export const checkLinkForEmbed = (link: string) => {
    const matchedPrefix = PREFIXES.find((prefix) => link.startsWith(prefix));

    if (
        (matchedPrefix && Boolean(link.slice(matchedPrefix.length))) ||
        checkR7Link(link) ||
        checkWebinar(link)
    ) {
        return true;
    }

    return false;
};

export const linkToEdit = (link: string) => {
    if (link.startsWith(GOOGLE_DOCS_DOCUMENT_LINK)) {
        return link.replace("/preview", "/edit");
    }

    if (link.startsWith(GOOGLE_DOCS_SPREADSHEETS_LINK)) {
        return link.replace("/preview", "/edit");
    }

    if (link.startsWith(GOOGLE_DOCS_PRESENTATION_LINK)) {
        return link.replace("/edit", "/preview");
    }

    return link;
};

export const replaceLink = (link: string | null) => {
    if (link === null) return null;

    if (link.startsWith(GOOGLE_DOCS_DOCUMENT_LINK)) {
        return link.replace("/edit", "/preview");
    }

    if (link.startsWith(GOOGLE_DOCS_SPREADSHEETS_LINK)) {
        return link.replace("/edit", "/preview");
    }

    if (link.startsWith(GOOGLE_DOCS_PRESENTATION_LINK)) {
        return link.replace("/edit", "/preview");
    }

    if (link.startsWith(GOOGLE_DOCS_FORMS_LINK)) {
        return link.replace("/edit", "/viewform");
    }

    if (link.startsWith(RUTUBE_LINK)) {
        return link.replace("/video", "/play/embed");
    }

    return link;
};

export const checkR7Link = (link: string) => {
    const regex = /^https:\/\/[\w-]+\.r7-office\.ru(\/.*)?$/;

    return regex.test(link);
};

export const checkWebinar = (link: string) => {
    const regex =
        /^https:\/\/[a-zA-Z0-9-]+\.mts-link\.ru\/\d+\/\d+\/record-new\/\d+(?:\/record-file\/\d+)?/;

    return regex.test(link);
};
